export class Credits {
  amount: number;
  name: string;
}
